import { useEffect, useState } from 'react';

/** A useMemo for you if you have some array of dependencies of unknown length (you cant statically destructure them) */
export function useShallowArrayMemo<T>(arr: T[]): T[] {
  const [memo, setMemo] = useState(arr);

  useEffect(() => {
    setMemo(prev => (prev.length === arr.length && prev.every((v, i) => v === arr[i]) ? prev : arr));
  }, [arr]);

  return memo;
}
